import { HighlightOffOutlined } from "@mui/icons-material";
import classNames from "classnames";
import { useEnvContext } from "contexts/EnvProvider";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { FeaturesFlags } from "helpers";
import { useAppDispatch, useImagePath, useWindowSize } from "hooks";
import { useLinks } from "hooks/useLinks";
import { useNavigate } from "react-router-dom";
import { closeStickyTag } from "redux/slices";
import {
	useGetStickyTag,
	useRefreshStickyStorage,
	useSetActiveSaleTag
} from "./hooks";
import { Body, Button, Sticky, TagBrush, Text, Tiki } from "./styles";

interface StickySaleTagProps {}

const StickySaleTag: React.FC<StickySaleTagProps> = () => {
	useSetActiveSaleTag();
	useRefreshStickyStorage();
	const { width } = useWindowSize();
	const dispatch = useAppDispatch();
	const stickyTag = useGetStickyTag();
	const navigate = useNavigate();
	const links = useLinks();
	const { getImage } = useImagePath("local");
	const { isFeatureFlagEnabled } = useEnvContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const tikiUrl = getImage("/spec_sticky_tag/tiki-sticky.png");
	const backgroundMobileUrl = getImage(
		"/spec_sticky_tag/line-brush-mobile.png"
	);
	const backgroundDesktopUrl = getImage(
		"/spec_sticky_tag/line-brush-desktop.png"
	);
	const isMobile = width <= 720;
	const className = classNames(isMobile && "mobile");

	const handleNavigate = () => {
		const linkEntry = Object.values(links).find(
			(link) => link?.title === stickyTag?.megaMenuTagSection
		);
		if (linkEntry?.path) {
			navigate(linkEntry.path);
		}
	};

	return stickyTag && isFeatureFlagEnabled(FeaturesFlags.STICKY_TAG) ? (
		<Sticky className={className}>
			<TagBrush
				data-image={isMobile ? backgroundMobileUrl : backgroundDesktopUrl}
				className={className}
				onClick={handleNavigate}
			>
				<Tiki className="tiki" src={tikiUrl} />
				<Body className="body">
					<Text className="text">{stickyTag.stickyTagText}</Text>
				</Body>
				<Button
					className="button"
					onClick={(event) => {
						event.stopPropagation();
						dispatch(closeStickyTag(stickyTag.id));

						//const { startTime, endTime, stickyTagText } = stickyTag;
						const { priority, stickyTagText } = stickyTag;
						reportEvent("hide_sticky_tag", {
							source: "sticky_tag",
							priority,
							//sale_start_time: startTime,
							//sale_end_time: endTime,
							stickyTagText: stickyTagText
						});
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "hide_sticky_tag",
							event_type: "sticky_tag",
							source: "sticky_tag",
							action: "hide_sticky_tag",
							priority,
							//time_total: moment(endTime).diff(startTime, "seconds"),
							tag_text: stickyTagText
						});
					}}
				>
					<HighlightOffOutlined
						sx={{
							strokeWidth: 0.005,
							width: 30,
							height: 30,
							backgroundColor: "rgba(0,0,0, .3)",
							borderRadius: "100%",
							color: "#fff",
							"&:hover": {
								backgroundColor: "rgba(0,0,0, .6)"
							}
						}}
						fontSize="large"
					/>
				</Button>
			</TagBrush>
		</Sticky>
	) : null;
};

export default StickySaleTag;
